export default () => ({
	isFiltersActive: false,
	activeSort: 'best-selling',

	changeSearchMainContent(url) {
		fetch(url)
			.then((res) => res.text())
			.then((data) => {
				const html = new DOMParser().parseFromString(data, 'text/html');
				const destination = document.querySelector('.search-main__grid-container');
				const source = html.querySelector('.search-main__grid-container');

				if (source && destination) {
					destination.innerHTML = source.innerHTML;
				}
			});
	},

	paginate() {
		const url =
			this.$el.querySelector('a').getAttribute('href') +
			`&section_id=${this.$root.dataset.sectionId}`;

		this.changeSearchMainContent(url);
		history.pushState({}, '', this.$el.querySelector('a').getAttribute('href'));
	},

	searchSort() {
		let data = new FormData(this.$el);
		let queryString = new URLSearchParams(data).toString();
		const activeSort = queryString
			.split('&')
			.find((element) => element.includes('sort_by'))
			?.split('=')[1];

		this.activeSort = activeSort || 'manual';

		let url_search = window.location.search;
		if (window.location.search.includes('&sort_by')) {
			url_search = window.location.search.split('&sort_by')[0];
		}
		const url = `${window.location.pathname}${url_search}&${queryString}`;

		this.changeSearchMainContent(url);
		history.pushState({}, '', url);
	},

	init() {
		window.addEventListener('popstate', () => {
			const url = document.location.href;

			this.changeSearchMainContent(url);
		});
	},
});
